// @react-functional

import React from 'react';
import { LoginModal } from './LoginModal';
import { ModalContext } from '../components/modal/ModalContext';
import { doctrineAnalytics } from '../utils/analyticsUtils';

export type WithLoginModalProps = {
  openLoginModal: (source?: string) => void;
};

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T extends K, K> = Omit<T, keyof K>;

export function withLoginModal<
  P extends React.ComponentType<React.ComponentProps<P> & WithLoginModalProps>,
  ResolvedProps = JSX.LibraryManagedAttributes<
    P,
    Subtract<React.ComponentProps<P>, WithLoginModalProps>
  >
>(WrappedComponent: P) {
  const ComponentWithLoginModal: React.FC<ResolvedProps> = props => (
    <ModalContext.Consumer>
      {({ openModal }) => (
        <WrappedComponent
          {...(props as JSX.LibraryManagedAttributes<
            P,
            React.ComponentProps<P>
          >)}
          openLoginModal={(source?: string) => {
            doctrineAnalytics('Account ModalLoginAppeared2', { source });
            openModal(modalProps => <LoginModal {...modalProps} />);
          }}
        />
      )}
    </ModalContext.Consumer>
  );
  return ComponentWithLoginModal;
}
